import React, { useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Collapse } from 'react-collapse';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
import { truncate } from 'Components/utils/string/string.util';
import { ICONS } from 'Components/utils/icon/icons';

export const ChildcareDescription = ({ description }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div>
      <Collapse initialStyle={{ minHeight: 45 }} isOpened={isExpanded}>
        <div className="flex flex-col">
          <button
            className="py-5 text-start"
            type="button"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {!!description && (
              <Text
                className={classnames({ 'line-clamp-2': !isExpanded })}
                text={isExpanded ? description : truncate(description, 150, true)}
              />
            )}
          </button>
        </div>
        <div className="text-right">
          <button type="button" onClick={() => setIsExpanded(!isExpanded)}>
            <Icon name={ICONS.ARROW_TOP} rotation={isExpanded ? 0 : 180} />
          </button>
        </div>
      </Collapse>
    </div>
  );
};
